export enum SiteID {
    ALL = 0,
    QM1 = 1,
    QM2 = 2,
    QM3 = 3,
    QM4 = 4,
    QMVIC = 5
}
